import { AlertTypeEnum } from "./alert-type-enum";


export class AlertOptions {
    title: string;
    text: string;
    icon: AlertTypeEnum;
    confirmButtonText: string;
    cancelButtonText: string;
    showCancelButton: boolean;
    html: string;
    input: any;
    inputPlaceholder: string;
    preConfirm: any;

}
